import React, { useRef } from 'react';
import { FormLabel, Box, Select, MenuItem, ListItemText } from '@mui/material';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { OverflowChips } from '@/components/OverflowChips';
import { useChipFit } from '@/hooks/useChipFit';

export const FundingStatusSelect = ({ fundingStatus, onChange, disabled }) => {
	const options = ['Quoted', 'Approved', 'Finalised', 'Unapproved'];

	const containerRef = useRef();
	const limitTags = useChipFit(containerRef, fundingStatus?.length ?? 0);

	return (
		<Box>
			<FormLabel>{'Funding Status'}</FormLabel>
			<Select
				ref={containerRef}
				multiple

				fullWidth
				disabled={disabled}
				value={fundingStatus || []}
				onChange={(event) => {
					onChange(event.target.value);
				}}
				renderValue={(selected) => (
					<OverflowChips items={selected} limitTags={limitTags} getLabel={(value) => value} />
				)}
				sx={{
					display: 'flex',
					maxHeight: 35,
					alignItems: 'center',
				}}
			>
				{options.map((item) => (
					<MenuItem key={item} value={item}>
						<ListItemText primary={item} />
					</MenuItem>
				))}
			</Select>
		</Box>
	);
};
